import { render, staticRenderFns } from "./PoliceNotificationDetailPage.vue?vue&type=template&id=4b67f8b8&scoped=true"
import script from "./PoliceNotificationDetailPage.vue?vue&type=script&lang=js"
export * from "./PoliceNotificationDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PoliceNotificationDetailPage.vue?vue&type=style&index=0&id=4b67f8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b67f8b8",
  null
  
)

export default component.exports